import { useLocation } from 'react-router';
import { handleLiveChatClick } from '../../utils/common';
import css from './StillHaveQuestions.module.scss';
import logNewRelicEvent, { newRelicEvents } from '../../utils/newRelicApiLogger';

export default function StillHaveQuestions() {
    const location = useLocation();

    return (
        <div className={css['still-have-questions-container']}>
            <h3>Still have questions?</h3>
            <p>Chat to us now, or go to our contact us page for more options</p>
            <div className={css['button-group']}>
                <button
                    className={css.button}
                    onClick={() => {
                        logNewRelicEvent({ eventName: newRelicEvents.userEvents.liveChat });
                        handleLiveChatClick();
                    }}
                >
                    Live Chat
                </button>
                <a
                    className={`${css.button} ${css['contact-us']}`}
                    onClick={e => {
                        logNewRelicEvent({ eventName: newRelicEvents.userEvents.contactUs });
                    }}
                    href={'https://www.foxtel.com.au/about/contact.html'}
                    target="_blank"
                >
                    Contact Us
                </a>
            </div>
        </div>
    );
}
